import config from "../../../Chat/config/config";
import constants from "../../../Chat/constants";
import Utilities from "../../../Helpers/Utilities";
import {
    AGENT_UPDATED,
    SESSION_UPDATED,
    MESSAGE_COUNT_UPDATED,
    MESSAGE_LIST_UPDATED,
    CHAT_STATE_CHANGED
} from "../Constants";

export function initChatToSocialMiner(userName, cb) {
    return function(dispatch) {
        console.log("POSTing a chat request to SocialMiner " + config.socialminer.host);

        const url = constants.scheme + config.socialminer.host + constants.chatURI;

        return $.post({
            url         : Utilities.buildUrl(url),
            data        : constructPostPayload(userName),
            contentType : constants.xmlMIMEType,
            crossDomain : true,
            xhrFields   : {
                withCredentials : true // Required to share session cookie while making cross-domain requests
            }
        }).done((data, textStatus, jqXHR) => {
            if (cb && typeof cb === "function") {
                cb(data, textStatus, jqXHR);
            }
        }).fail((jqXHR, textStatus) => {
            console.error("Failed to initiate chat request! Response status = " + jqXHR.status);
        });
    }
}

export function getChatEvents(session, cb) {
    return function(dispatch) {
        console.log("GETting chat events from SocialMiner " + config.socialminer.host + " since eventid " + session.latesteventid);

        $.get({
            url         : Utilities.buildUrl(constants.scheme + config.socialminer.host + constants.chatURI + constants.chatEventsPathParam + session.latesteventid),
            crossDomain : true,
            xhrFields   : { withCredentials: true } // Required to share session cookie while making cross-domain requests
        }).done((data, textStatus, jqXHR) => {
            if (cb && typeof cb === "function") {
                cb(data, textStatus, jqXHR);
            }
        });
    }
}

export function putChatMessage(message, cb) {
    return function(dispatch) {
        console.log("PUTting chat message to SocialMiner " + config.socialminer.host + ". Message = [" + message + "]");

        // silly jQuery does not have a $.put() ?!
        return $.ajax({
            type        : "PUT",
            url         : Utilities.buildUrl(constants.scheme + config.socialminer.host + constants.chatURI),
            data        : constructMessagePayload(message),
            contentType : constants.xmlMIMEType,
            crossDomain : true,
            xhrFields   : { withCredentials: true } // Required to share session cookie while making cross-domain requests
        }).done((data, textStatus, jqXHR) => {
            if (cb && typeof cb === "function") {
                cb(data, textStatus, jqXHR);
            }
        });
    }
}

export function deleteChat(cb) {
    return function(dispatch) {
        console.log("DELETEing chat session with SocialMiner " + config.socialminer.host);

        // silly jQuery does not have a $.delete() ?!
        return $.ajax({
            type        : "DELETE",
            url         : Utilities.buildUrl(constants.scheme + config.socialminer.host + constants.chatURI),
            crossDomain : true,
            xhrFields   : { withCredentials: true } // Required to share session cookie while making cross-domain requests
        }).done((data, textStatus, jqXHR) => {
            if (cb && typeof cb === "function") {
                cb(data, textStatus, jqXHR);
            }
        });
    }
}

export function updateSession(session) {
    return {
        type: SESSION_UPDATED,
        payload: session
    };
}

export function updateChatState(open) {
    return {
        type: CHAT_STATE_CHANGED,
        payload: open
    };
}

export function updateMessageCount(count) {
    return {
        type: MESSAGE_COUNT_UPDATED,
        payload: count
    };
}

export function updateMessageList(message) {
    return {
        type: MESSAGE_LIST_UPDATED,
        payload: message
    };
}

export function updateAgent(value) {
    return {
        type: AGENT_UPDATED,
        payload: value
    };
}

function constructPostPayload(userName) {
    const feedRefURL = constants.scheme + config.socialminer.host + constants.feedRefURL + config.chat.feedid;

    const chatPostPayload = `
        <SocialContact>
            <feedRefURL>${feedRefURL}</feedRefURL>
            <author>${userName}</author>
            <title>${config.chat.title}</title>
            <name>${config.chat.name}</name>
            <extensionFields>
                <extensionField>
                    <name>ccxqueuetag</name>
                    <value>${constants.ccx_chat_csq_tag + config.chat.ccx_csq_id}</value>
                </extensionField>
                <extensionField>
                    <name>h_widgetName</name>
                    <value>${config.chat.widgetName}</value>
                </extensionField>
            </extensionFields>
        </SocialContact>
    `;

    console.log("Chat request (POST) : " + chatPostPayload);
    return chatPostPayload;
}

function constructMessagePayload(message) {
    //JIRA, STORE-260
    message = message.replace(new RegExp("&" + "#" + "x27;", "g"), "'");

    const chatMessagePayload = `
            <Message>
                <body>${message}</body>
            </Message>
        `;

    console.log("Chat message (PUT) : " + chatMessagePayload);
    return chatMessagePayload;
}